import { TYPE_ADMIN } from '@/modules/users/decorator/userDecorator.js'

export const canAccessToUsers = function (store) {
  return [TYPE_ADMIN].includes(store.type)
}

export const checkGuest = function (store) {
  return !store.isGuest
}
